import React, { Component } from 'react';
import { connect } from 'react-redux';
import { deletePaymentMethod, updateDefaultPaymentMethod, updatePaymentMethodInfo, getCustomerPaymentMethods } from '../modules/payment_methods';
import { setupHostedFields, setupPaypal, resetPaypalListener, braintreeObjCreate, braintreeObjDestroy  } from '../shared/braintreeClientHelper';
import PayPalButton from './PayPalButton.jsx';

class CustomBraintreeUpdater extends Component {

  constructor(props) {
    super(props);
    this.braintreeObj = null;
    this.oSelected    = null;
    this.oUpdating    = null;
    this.state        = {
      viewState :  props.paymentMethods ? 'selected' :'none',
      didBrainTreeSubmit: false,
      updatedFormObj : null,
      cvvError: false,
      braintreeErrorObj: null
    };

    this.viewNone                   = this.viewNone.bind(this);
    this.viewSelected               = this.viewSelected.bind(this);
    this.viewSelectedHard           = this.viewSelectedHard.bind(this);
    this.viewAll                    = this.viewAll.bind(this);
    this.viewAdd                    = this.viewAdd.bind(this);
    this.viewUpdate                 = this.viewUpdate.bind(this);
    this.viewDelete                 = this.viewDelete.bind(this);
    this.viewDeleteDefault          = this.viewDeleteDefault.bind(this);

    this.closePopup                 = this.closePopup.bind(this);
    this.closeDeleteView            = this.closeDeleteView.bind(this);
    this.closeUpdateView            = this.closeUpdateView.bind(this);

    this.submitDelete               = this.submitDelete.bind(this);
    this.submitUpdate               = this.submitUpdate.bind(this);
    this.submitUpdateDefault        = this.submitUpdateDefault.bind(this);

    this.braintreeRefresh           = this.braintreeRefresh.bind(this);
    this.braintreeInstantiate       = this.braintreeInstantiate.bind(this);
    this.addNewSubmit               = this.addNewSubmit.bind(this);
    this.braintreeFailure           = this.braintreeFailure.bind(this);
  }

  componentWillReceiveProps(nextProps){
    if(this.props.paymentMethods !== nextProps.paymentMethods) {
      if( nextProps.paymentMethods && nextProps.paymentMethods[0] ){

        if(this.state.didBrainTreeSubmit === true) this.setState({ didBrainTreeSubmit: false});
        if(this.state.viewState === 'add') braintreeObjDestroy();
        if( this.state.viewState !== 'edit' ) this.oUpdating = null;
        if( this.state.viewState !== 'delete' ) this.deleteToken = null;

        if(this.state.viewState === 'none' || this.state.viewState === 'selected'){
          this.viewSelectedHard();
        }

        this.oSelected = null;
        this.oPaypalObj = null;
      } else if( !this.props.paymentMethods || !this.props.paymentMethods[0]){
        this.viewNone();
      }
    } else if( !nextProps.paymentMethods || !nextProps.paymentMethods[0] && this.props.viewState === 'selected'  ){
      this.viewNone();
    }
  }

  braintreeInstantiate(){
    let { font_css, customer, tla } = this.props;
    setupHostedFields( "updater-container", font_css, "custom-updater-submit", this.addNewSubmit, this.braintreeFailure )
    setupPaypal( "updater-paypal-container", this.addNewSubmit, this.braintreeFailure)
    braintreeObjCreate(customer.braintree_token, tla);
  }

  braintreeFailure(err){
    console.log(err);
    this.setState({ braintreeErrorObj : { message : 'Please fill in all the fields.' } });
  }

  addNewSubmit(obj){
    let { dispatch } = this.props;
    this.setState({ braintreeErrorObj : {} });
    if( this.state.didBrainTreeSubmit === false ){
      this.newPayPalObj = null;
      this.setState({
        braintreeErrorObj : {},
        didBrainTreeSubmit: true
      });

      this.props.dispatch(updateDefaultPaymentMethod(obj.nonce, null, this.braintreeRefresh));
      this.viewSelectedHard();
    }
  }

  braintreeRefresh(){
    let self = this;
    self.props.dispatch( getCustomerPaymentMethods() );
    setTimeout( function(){
      self.setState({ didBrainTreeSubmit : false });
    }, 1000);
  }

  closePopup(){
    if(this.state.viewState === 'delete') this.deleteToken = null;
    else if (this.state.viewState === 'add') braintreeObjDestroy();
    else if(this.state.viewState === 'edit') {
      this.oUpdating = null;
      this.state.updatedFormObj = null;
    }

    if(this.oSelected) this.viewSelectedHard();
    else this.viewNone();
  }

  closeUpdateView(){
    this.oUpdating = null;
    this.state.updatedFormObj = null;
    this.viewAll();
  }

  closeDeleteView(){
    this.viewAll();
    this.deleteToken = null;
  }

  submitDelete(){
    if(this.deleteToken) this.props.dispatch( deletePaymentMethod(this.deleteToken, this.braintreeRefresh ) );
    this.viewAll();
  }

  submitUpdate(){
    this.setState({ cvvError: false });
    if( !(/^[0-9]{3,4}$/.test(this.state.updatedFormObj.cvv)) ){
      this.setState({ cvvError: true });
    } else if ( this.state.didBrainTreeSubmit === false ){

      this.setState({didBrainTreeSubmit: true});
      if(this.state.updatedFormObj.expD === this.oUpdating.expirationDate) delete this.state.updatedFormObj.expD;

      this.props.dispatch( updatePaymentMethodInfo( this.state.updatedFormObj, this.braintreeRefresh ));
      this.state.updatedFormObj = null;
      this.viewAll();
    }
  }

  submitUpdateDefault(paymentMethodObj){
    this.setState({ viewState: 'selected'});
    this.oSelected = paymentMethodObj;
    if ( this.state.didBrainTreeSubmit === false  ){
      this.setState({ didBrainTreeSubmit: true });
      this.props.dispatch( updateDefaultPaymentMethod(null, this.oSelected.token, this.braintreeRefresh) );
    }
  }

  updateChange(key, event){
    let tempUpdatedFormObj = this.state.updatedFormObj;
    tempUpdatedFormObj[key] = event.target.value;
    this.setState({ updatedFormObj: tempUpdatedFormObj});
  }

  viewAll(){
    braintreeObjDestroy();
    this.setState({ viewState: 'listAll'});
  }

  viewAdd(){
    this.setState({ viewState: 'add'});
    let self = this;
    setTimeout( () => self.braintreeInstantiate(), 250);
  }

  viewSelected(){
    if( !this.props.paymentMethods || this.props.paymentMethods[0] === null) this.setState({viewState: 'none'});
    else if(this.state.viewState !== 'listAll' ) this.setState({ viewState: 'selected'});
  }

  viewSelectedHard(){ this.setState({ viewState: 'selected'}); }
  viewNone(){ this.setState({ viewState: 'none'}); }
  viewDeleteDefault(){ this.setState({viewState: 'deleteDefault'}) }

  viewDelete(token){
    if( this.deleteToken !== token ){
      this.setState({viewState: 'delete'});
      this.deleteToken = token;
    }
  }

  viewUpdate(method){
    if( this.oUpdating !== method ){
     this.setState({ viewState: 'edit'});
      this.oUpdating = method;
    }
  }

  render() {
    let oPaymentMethodList             = '',
        elem                           = '',
        oSelectedObj                   = '',
        oPaypalObj                     = '',
        oSelectedButton                = '',
        oShowChangePaymentMethodButton = '',
        editPaymentMethodObj           = '',
        paymentError                   = '',
        braintreeEmbedElem             = '',
        braintreePopupElem             = '',
        popupContents                  = null,
        popupBackDrop                  = '',
        paymentMethods                 = this.props.paymentMethods,
        braintreeErrors                = this.state.braintreeErrorObj,
        currentView                    = this.state.viewState;


    if(this.state.didBrainTreeSubmit === true) oSelectedButton = (<div className="errorMessage">Updating...</div>);
    else oShowChangePaymentMethodButton = ( <div className="edit-link" onClick={this.viewAll}>edit payment methods</div>);

    if(this.props.braintreeFailure && !this.state.didBrainTreeSubmit ) paymentError = (<div className="errorMessage">{this.props.braintreeFailure}</div>);

    if( currentView !== 'selected' && currentView !== 'paypalSelected' && ( !paymentMethods || !paymentMethods[0]) ){
      braintreeEmbedElem = (
        <div className="noPaymentMethod showing">
          <p>You do not have a payment method on file. Please add a payment method to make a purchase.</p>
          <button className="btn-primary full-width" onClick={this.viewAdd}>Add Payment Method</button>
        </div>
      );
    //selected
    } else if(currentView !== 'none' && paymentMethods && paymentMethods[0]){
      oPaymentMethodList = paymentMethods.map((method, i) => {
        if ( method && typeof method === 'object' ) {

          if(this.oSelected === null && method.default === true ) this.oSelected = method;

          let oSetDefault = method.default === false ?
            (<div className="button btn-tertiary" onClick={this.submitUpdateDefault.bind(this, method)} > Set Default </div>) :
            (<span className="text-small"><em>Default</em></span>);

          let editButton = method.cardType ? ( <div className="button btn-tertiary" onClick={this.viewUpdate.bind(this, method )}>edit</div>) : '';
          let deleteButton = method.default === true ? (<div className="button btn-tertiary" onClick={this.viewDeleteDefault}>delete</div>) :
              (<div className="button btn-tertiary" onClick={this.viewDelete.bind(this, method.token)}>delete</div>) ;

          let sCardType = method.cardType;
          if (method.cardType === 'American Express' ) sCardType = 'AmEx';

          return (
            <li key={'PaymentMethod' + i} className={ (this.deleteToken && this.deleteToken === method.token) || ( this.oUpdating && this.oUpdating === method ) ? "loading" : ''} >
              { method.cardType ? sCardType + " ending in " + method.last4 : "PayPal " + method.email }
              <div className={"actionButtons" + (this.deleteToken && this.deleteToken === method.token ? " hidden" : ' showing')} >
                {oSetDefault}
                {editButton}
                {deleteButton}
              </div>
            </li>
          );
        } else {
          return '';
        }
      });

      if( this.oSelected ){
        oSelectedObj = (
            <li className={ (this.state.didBrainTreeSubmit === false ? "" : "loading" )} >
              { this.oSelected.cardType ? this.oSelected.cardType + " ending in " + this.oSelected.last4 : "PayPal " + this.oSelected.email }
            </li>
          );
      }

      braintreeEmbedElem = (
        <div className="selectedPayment showing">
          { currentView === 'paypalSelected' ? oPaypalObj : oSelectedObj}
          {oShowChangePaymentMethodButton}
        </div>
      );
    }

    if (currentView !== 'none' && currentView !== 'selected' && currentView !== 'paypalSelected' ) popupBackDrop = ( <div className="modal-wrapper showing" onClick={this.closePopup}></div>);

    switch(currentView){
      case 'listAll':
        popupContents = (
          <ul className="paymentMethodList editable showing">
            {oPaymentMethodList}
            <li className="button" onClick={this.viewAdd}><div className="btn-icon">+</div>Add Another Payment Method</li>
            <div className="help-link center" onClick={this.closePopup}>cancel</div>
          </ul>
        );
        break;
      case 'add':
        popupContents = (
          <div className="hostedFieldForm showing" id="updater-container">
            <h4 className="center alt2">Please enter your payment method</h4>
            {(braintreeErrors && braintreeErrors.message) || (this.props.braintreeFailure && !this.state.didBrainTreeSubmit) ?
              (<p className="errorMessage">{ braintreeErrors && braintreeErrors.message ? braintreeErrors.message : this.props.braintreeFailure }</p>) : ''}
            <label>Credit Card Number</label>
            <div id="card-number" className="hostedFieldInput"></div>

            <label>CVV</label>
            <div id="cvv" className="hostedFieldInput"></div>

            <label>Expiration Date (MM/YYYY)</label>
            <div id="expiration-date" className="hostedFieldInput"></div>

            <label>Zipcode</label>
            <div id="postalCode" className="hostedFieldInput"></div>

            <button disabled={true} id="custom-updater-submit" className="btn-primary fat full-width" type="submit">{ this.state.didBrainTreeSubmit === false ? "SAVE PAYMENT METHOD" : "Updating..." }</button>

            { this.props.tla === "DVD" ? (<div />) : (
              <div id="updater-paypal-container" className="bt-paypal-button">
                <PayPalButton />
              </div>
            )}

            <div className="help-link center" onClick={this.oSelected ? this.viewAll : this.viewNone}>cancel</div>
          </div>
        );
        break;
      case 'edit':
        if( this.state.updatedFormObj === null){
          this.state.updatedFormObj = {
            token: this.oUpdating.token,
            cvv: "",
            expD: this.oUpdating.expirationDate,
            postalCode: this.oUpdating.billingAddress.postalCode
          }
        }

        let oErrorMessage = this.state.cvvError === true ? (<p className="errorMessage">You must supply your 3-4 digit cvv to update your payment method.</p>) : '';

        popupContents = (
          <div className={"editPaymentMethod" + (currentView === 'edit' ? ' showing ': " hidden")}>
            <h4 className="center alt2">Current Payment Method Info</h4>

            <label>Credit Card Number</label>
            <input id="card-number" className="editInput" value={this.oUpdating.maskedNumber} readOnly />

            <label>CVV (required)</label>
            <input id="cvv" className={"editInput" + (this.state.cvvError === true ? "errorMessage" : "")}  value={this.state.updatedFormObj.cvv} onChange={this.updateChange.bind( this, 'cvv')} />
            {oErrorMessage}
            <label>Expiration Date (MM/YYYY)</label>
            <input id="expiration-date" className="editInput"  value={this.state.updatedFormObj.expD} onChange={this.updateChange.bind( this, 'expD')} />

            <label>Zipcode</label>
            <input id="postalCode" className="editInput" value={this.state.updatedFormObj.postalCode} onChange={this.updateChange.bind( this, 'postalCode')} />

            <button className="btn-primary fat full-width" onClick={this.submitUpdate} >
              { this.state.didBrainTreeSubmit === false ? "SAVE PAYMENT METHOD" : "Updating..." }
            </button>
            <div className="help-link center" onClick={this.closeUpdateView}>cancel</div>
          </div>
        );
        break;
      case 'delete':
        popupContents = (
          <div className="comfirmDelete center showing">
            <h4 className="center">Are you sure you want to delete this payment method?</h4>
            <button className="btn-primary fat" onClick={this.submitDelete}>Yes, delete</button>
            <button className="btn-secondary fat" onClick={this.closeDeleteView}>No</button>
          </div>
        );
        break;
      case 'deleteDefault':
        popupContents = (
          <div className={"deleteDefault center" + (currentView === 'deleteDefault' ? " showing" : " hidden")}>
            <h4 >You must add a new payment method before deleting your default payment method.</h4>
            <button className="btn-secondary fat full-width" onClick={ !paymentMethods || !paymentMethods[0] ? this.viewNone : this.viewAll}>Ok</button>
          </div>
        );
        break;
    }

    if( popupContents ) {
      braintreePopupElem = (
        <div className="modal-window showing">
          <div className="modal-close" onClick={this.closePopup}>&times;</div>
          <h2>Select/Edit a Payment Method</h2>
          {popupContents}
        </div>
      );
    }

    return (
      <div className="braintreeObj">
        {paymentError}
        {popupBackDrop}
        {braintreeEmbedElem}
        {oSelectedButton}
        {braintreePopupElem}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer,
      'tla': state.store.tla,
      'paymentMethods': state.paymentMethods,
      'braintreeFailure': state.braintreeFailure,
      'font_css': state.store.font_css
    };
}

export default connect(mapStateToProps)(CustomBraintreeUpdater);


// WEBPACK FOOTER //
// ./src/components/CustomBraintreeUpdater.jsx